import router from './router';
import store from './store';
import {
	Message
} from 'element-ui';
import {
	reqGetUserInfo
} from '@/api'

const examList = ['/agreement', '/form', '/form-info', '/login', '/search', '/sign-up'];
const frequentlyList = ['/photo', '/info-maintain', '/pay', '/refund', '/confirm', '/admission', '/interview'];
let old_time = 0;

router.beforeEach((to, form, next) => {
	if (to.params.unit) {
		if (to.params.test) {
			sessionStorage.setItem('test', to.params.test || '');
		}
		sessionStorage.setItem('unit', to.params.unit || '');
	}
	const unit = sessionStorage.getItem('unit') || '',
		test = sessionStorage.getItem('test') || '';
	if (unit) {
		const {
			id,
			name,
		} = store.state.user.examinee;
		if (to.path === '/') {
			const store = form.matched[0].instances.default.$store;
			if (store.state.system.sign_up) {
				clearTimeout(store.state.system.sign_up);
			}
			next(`/${unit}${test?`/${test}`:''}`);
		} else if (to.path === `/${unit}${test?`/${test}`:''}` || to.path === `/${unit}`) {
			next();
		} else if (store.state.system.examInfo.examination_id) {
			if (examList.includes(to.path)) {
				next();
			} else if (id && name) {
				let now_time = new Date().getTime();
				if(frequentlyList.includes(to.path) && ((now_time - old_time)/1000 < 2)){
					Message.info('请勿频繁操作！！！');
					next(false);
				}else {
					old_time = now_time;
					next();
				}
			} else {
				next('/login')
			}
		}
	} else if (to.path === '/') {
		next();
	} else {
		next('/');
	}
})
